module.exports = __webpack_public_path__ + "img/dt-logo-lockup-hz-wht-aug2017.af462094.png";